import { useRef, useMemo, useCallback } from 'react'
import { useMutationObservable, DEFAULT_OPTIONS } from './useMutationObservable'

const options = {
	...DEFAULT_OPTIONS,
	debounceTime: 200,
}

export const useElementHeight = ({ selector, onChange } = {}) => {
	const cache = useRef(0)
	const el = useMemo(() => (selector instanceof HTMLElement ? selector : document.querySelector(selector)), [selector])

	const onMutation = useCallback(() => {
		if (el) {
			const rect = el.getBoundingClientRect()
			if (rect.height !== cache.current) {
				cache.current = rect.height
				if (onChange) onChange(rect.height)
			}
		}
	}, [el, onChange])

	useMutationObservable(el, onMutation, options)
}
